import React, {useEffect} from "react";
import Styles from './styles.module.scss';
import {useSelector} from "react-redux";
import CabinetLeaderboardMain from "../../components/cabinetLeaderboardMain";
import {useNavigate} from "react-router-dom";



const CabinetLeaderboardPage = () => {
    const navigate = useNavigate();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-in');
        }
    },[authStatus, navigate])

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <CabinetLeaderboardMain/>
            </div>
        </section>
    );
};

export default CabinetLeaderboardPage;
